<table class="table table-bordered">
  <thead>
    <tr>
      <th>Quote #</th>
      <th>Quotation Date</th>
      <th>Value</th>
      <th>Status</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let quotation of filteredQuotations">
      <td>{{ quotation.quotationFields.id }}</td>

      <td>{{ quotation.quotationFields.quotationDate | date:'dd/MM/yyy' }}</td>
      <td>{{ quotation.quotationFields.grandTotal}}</td>
      <td>{{ quotation.quotationFields.quotationStatus}}</td>
      <td>
        <button (click)="viewQuotation(quotation)" class="btn btn-primary btn-sm" [disabled]="!hasPermission(quotation.quotationFields.quotationStage)">
          <i class="fa fa-eye" aria-hidden="true"></i>
        </button>
      </td>
    </tr>
  </tbody>
</table>
